import React, { useEffect, useState } from 'react';
import { Routes, Route, Outlet, Navigate, useNavigate, useLocation } from 'react-router-dom';
import Globals from './constants/index';
import $ from 'jquery';
import Sns1 from 'assets/mobile/img/common/m_sns_list1.png';
import Sns2 from 'assets/mobile/img/common/m_sns_list2.png';
import './assets/styles/css/common.scss';
import './assets/mobile/css/common.scss';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import 'swiper/swiper-bundle.min.css';
import 'swiper/swiper.min.css';
import './app.scss';
import { isDesktop, isMobile } from 'react-device-detect';
import ReactGA from "react-ga";

// Common
const Header = React.lazy(() => import('./common/components/Header/index'));
const HeaderMobile = React.lazy(() => import('./common/components/Mobile/Header/index'));
const HomePage = React.lazy(() => import('./pages/HomePage/index'));
// Value
const M11 = React.lazy(() => import('./pages/SubPages/Value/components/m11'));
const M12 = React.lazy(() => import('./pages/SubPages/Value/components/m12'));
const M13 = React.lazy(() => import('./pages/SubPages/Value/components/m13'));
// Program
const M21 = React.lazy(() => import('./pages/SubPages/Program/components/m21'));
const M22 = React.lazy(() => import('./pages/SubPages/Program/components/m22'));
const M23 = React.lazy(() => import('./pages/SubPages/Program/components/m23'));
// Campus
const M31 = React.lazy(() => import('./pages/SubPages/Campus/components/m31'));
const M32 = React.lazy(() => import('./pages/SubPages/Campus/components/m32'));
// Pr
const M42 = React.lazy(() => import('./pages/SubPages/Pr/components/m42'));
const M43 = React.lazy(() => import('./pages/SubPages/Pr/components/m43'));
// Franchise
const M51 = React.lazy(() => import('./pages/SubPages/Franchise/components/m51'));
const M52 = React.lazy(() => import('./pages/SubPages/Franchise/components/m52'));
const M53 = React.lazy(() => import('./pages/SubPages/Franchise/components/m53'));
const M54 = React.lazy(() => import('./pages/SubPages/Franchise/components/m54'));
// Kid-Teacher
const M61 = React.lazy(() => import('./pages/SubPages/Kid-Teacher/components/m61'));
// Board
const Festival = React.lazy(() => import('./pages/SubPages/Board/components/festival'));
const FestivalDetail = React.lazy(() => import('./pages/SubPages/Board/components/festivalDetail'));
const News = React.lazy(() => import('./pages/SubPages/Board/components/news'));
const NewsDetail = React.lazy(() => import('./pages/SubPages/Board/components/newsDetail'));
const BoardNotice = React.lazy(() => import('./pages/SubPages/Board/components/notice'));
const BoardNoticeDetail = React.lazy(() => import('./pages/SubPages/Board/components/noticeDetaill'));
const BoardMaster = React.lazy(() => import('./pages/SubPages/Board/components/master'));
const BoardMasterDetail = React.lazy(() => import('./pages/SubPages/Board/components/masterDetail'));
const Review = React.lazy(() => import('./pages/SubPages/Board/components/review'));
const ReviewCreate = React.lazy(() => import('./pages/SubPages/Board/components/reviewCreate'));
// Account
const Login = React.lazy(() => import('./pages/SubPages/Account/Login/index'));
const Register = React.lazy(() => import('./pages/SubPages/Account/Register/index'));
const RegisterCompleted = React.lazy(() => import('./pages/SubPages/Account/Register/completed'));
const FindPassword = React.lazy(() => import('./pages/SubPages/Account/FindPassword/index'));
const ResetPassword = React.lazy(() => import('./pages/SubPages/Account/ResetPassword/index'));
// Personal
const PersonalNotice = React.lazy(() => import('./pages/SubPages/Personal/components/Notice/index'));
const InformationModify = React.lazy(() => import('./pages/SubPages/Personal/components/InformationModify/index'));
const WorkBook = React.lazy(() => import('./pages/SubPages/Personal/components/WorkBook/index'));
const Reservation = React.lazy(() => import('./pages/SubPages/Personal/components/Reservation/index'));
const Attendance = React.lazy(() => import('./pages/SubPages/Personal/components/Attendance/index'));


function App(props) {
    ReactGA.initialize('UA-216476453-1');
    ReactGA.pageview(window.location.pathname + window.location.search);
    let navigate = useNavigate();
    let location = useLocation();
    
    const [userInfo] = useState(JSON.parse(localStorage.getItem('userInfo')));
    const [stateUser, setStateUser] = useState(false);

    useEffect(() => {
        userInfo && userInfo !== null ? setStateUser(true) : setStateUser(false)
    }, [userInfo]);

    const handleLogout = () => {
        localStorage.removeItem('userInfo');
        setStateUser(false);
        navigate('/');
    }
    const goToTop = () => {
        $('body,html').animate({ scrollTop: 0 }, 300);
    }

    return (
        <React.Fragment>
            <div className="ie_alert_text"></div>
            <div id="bg"></div>
            <div id="layer-popup" className="popup-wrap"></div>
            <div id="wrap" className={location.pathname !== '/' ?? ''}>
                <React.Suspense fallback={<div className="loading-page"><img src={Globals.LOADING_ICON} alt="" /></div>}>
                    <header>
                        {isDesktop ?
                            <Header handleLogout={handleLogout} />
                            : <HeaderMobile handleLogout={handleLogout} />
                        }
                    </header>
                    <div id="contents">
                        <div id="container">
                            <main role="main">
                                <Routes>
                                    <Route path='*' element={<Navigate to="/" />} />
                                    <Route path="/" element={<HomePage />} />
                                    <Route path="value" element={<Outlet />} >
                                        <Route index element={<M11 pn={1} sn={1} />} />
                                        <Route path="m12" element={<M12 pn={1} sn={2} />} />
                                        <Route path="m13" element={<M13 pn={1} sn={3} />} />
                                    </Route>
                                    <Route path="program" element={<Outlet />} >
                                        <Route index element={<M21 pn={2} sn={1} />} />
                                        <Route path="m22" element={<M22 pn={2} sn={2} />} />
                                        <Route path="m23" element={<M23 pn={2} sn={3} />} />
                                    </Route>
                                    <Route path="campus" element={<Outlet />} >
                                        <Route index element={<M31 pn={3} sn={1} />} />
                                        <Route path="m32" element={<Outlet />}>
                                            <Route index element={<M32 pn={3} sn={2} />} />
                                        </Route>
                                    </Route>
                                    <Route path="pr" element={<Outlet />} >
                                        <Route path="m42" element={<M42 pn={4} sn={2} />} />
                                        <Route path="m43" element={<M43 pn={4} sn={3} />} />
                                    </Route>
                                    <Route path="franchise" element={<Outlet />} >
                                        <Route index element={<M51 pn={5} sn={1} />} />
                                        <Route path="m52" element={<M52 pn={5} sn={2} />} />
                                        <Route path="m53" element={<M53 pn={5} sn={3} />} />
                                        <Route path="m54" element={<M54 pn={5} sn={4} />} />
                                    </Route>
                                    <Route path="kid-teacher" element={<Outlet />} >
                                        <Route index element={<M61 pn={6} sn={1} />} />
                                    </Route>
                                    <Route path="board" element={<Outlet />} >
                                        <Route path="festival" element={<Outlet />} >
                                            <Route index element={<Festival pn={2} sn={4} />} />
                                            <Route path=":festivalId" element={<FestivalDetail pn={2} sn={4} />} />
                                        </Route>
                                        <Route path="news" element={<Outlet />} >
                                            <Route index element={<News pn={4} sn={1} />} />
                                            <Route path=":newsId" element={<NewsDetail pn={4} sn={1} />} />
                                        </Route>
                                        <Route path="notice" element={<Outlet />} >
                                            <Route index element={<BoardNotice pn={3} sn={4} />} />
                                            <Route path=":noticeId" element={<BoardNoticeDetail pn={3} sn={4} />} />
                                        </Route>
                                        {/* check login for master page */}
                                        <Route path="master" element={<Outlet />} >
                                            <Route index element={<BoardMaster pn={6} sn={2} />} />
                                            <Route path=":masterId" element={<BoardMasterDetail pn={6} sn={2} />} />
                                        </Route>
                                        <Route path="review" element={<Outlet />} >
                                            <Route index element={<Review pn={3} sn={3} />} />
                                            <Route path="create" element={<ReviewCreate pn={3} sn={3} />} />
                                        </Route>
                                    </Route>
                                    <Route path="account" element={<Outlet />}>
                                        <Route path="login" element={stateUser ? <Navigate to="/" replace /> : <Login />}></Route>
                                        <Route path="register" element={<Outlet />}>
                                            <Route index element={stateUser ? <Navigate to="/" replace /> : <Register />}></Route>
                                            <Route path="completed" element={<RegisterCompleted />}></Route>
                                        </Route>
                                        <Route path="find-password" element={<FindPassword />}></Route>
                                        <Route path="reset-password/:code" element={<ResetPassword />}></Route>
                                    </Route>
                                    <Route path="personal" element={<Outlet />}>
                                        <Route path="notice" element={<PersonalNotice />}></Route>
                                        <Route path="work-book" element={<WorkBook />}></Route>
                                        <Route path="reservation" element={<Reservation />}></Route>
                                        <Route path="attendance" element={<Attendance />}></Route>
                                        <Route path="infomation-modify" element={<InformationModify />}></Route>
                                    </Route>
                                </Routes>
                            </main>
                        </div>
                    </div>
                    {isMobile ?
                        <div className="sns_wrap">
                            <ul>
                                <li className="page_top" onClick={goToTop}>TOP</li>
                                <li>
                                    <a href="http://talk.naver.com/W4TPGO" rel="noreferrer" target="_blank">
                                        <img src={Sns1} alt="" />
                                    </a>
                                </li>
                                <li>
                                    <a href="http://pf.kakao.com/_tNxbxij" rel="noreferrer" target="_blank">
                                        <img src={Sns2} alt="" />
                                    </a>
                                </li>
                            </ul>
                        </div> : ''}
                </React.Suspense>
            </div>
        </React.Fragment>
    );
}

export default App;
